import React from 'react';

/**
 * Catches render errors so the app shows a visible fallback instead of a blank screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const label = this.props.name || 'ErrorBoundary';
    console.error(`[${label}] render error:`, error, info?.componentStack);
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, info);
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.error) {
      const title = this.props.title || 'Something went wrong — retry';
      return (
        <div
          className="min-h-[200px] p-6 m-4 rounded-lg border border-danger/40 bg-bone-raised"
          role="alert"
        >
          <p className="font-display text-h3 text-ink mb-2">{title}</p>
          <p className="text-body text-ink-muted mb-4">
            {this.state.error.message || 'An unexpected error occurred.'}
          </p>
          <button type="button" className="btn-secondary" onClick={this.handleRetry}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
